import React from 'react';
import { CheckIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { heroChecks } from '../../data/content';
import { MOCKUP_IMAGE } from '../../data/links';
type HeroProps = {
  ctaRef: React.RefObject<HTMLAnchorElement>;
};
export function Hero({
  ctaRef
}: HeroProps) {
  return <header className="bg-navy text-white" data-id="element-178" data-mp="hwin3ixf8avl">
      <div className="bg-gold px-3 py-2 text-center text-[11px] font-extrabold uppercase tracking-wide text-navy md:text-xs" data-id="element-179" data-mp="muadu9mbxqy7">
        For Surgical Nurses &amp; Postoperative Care Professionals
      </div>

      <div className="mx-auto grid max-w-6xl gap-6 px-5 pb-14 pt-8 md:grid-cols-2 md:gap-x-12 md:pb-20 md:pt-14" data-id="element-180" data-mp="vmm0dkebou8w">
        <div className="text-center md:col-start-1 md:row-start-1 md:text-left" data-id="element-181" data-mp="10lozypbja89h">
          <p className="text-sm font-bold text-gold" data-id="element-182" data-mp="15ks1hzsb1wcp">Postoperative Wound Complications Blueprint™</p>
          <h1 className="mt-3 text-[29px] font-extrabold leading-[1.13] tracking-tight md:text-5xl md:leading-[1.08]" data-id="element-183" data-mp="1aj3egjdwcmz5">
            Turn Scattered Post-Op Wound Findings Into a{' '}
            <span className="text-gold" data-id="element-184" data-mp="4opsy808q36r">Structured 5-Step Assessment &amp; Escalation Workflow</span>
          </h1>
          <p className="mt-4 text-base leading-relaxed text-white/80 md:text-lg" data-id="element-185" data-mp="3vurc73ud033h">
            In one organized clinical review. Stop relying on scattered notes, inconsistent observations, and unclear
            communication pathways.
          </p>
        </div>

        <div className="-mx-2 md:col-start-2 md:row-span-2 md:row-start-1 md:mx-0 md:self-center" data-id="element-186" data-mp="sgepy1o0bfu1">
          <img src={MOCKUP_IMAGE} alt="Postoperative Wound Complications Blueprint: 6 volumes, 5 bonuses and documentation templates" className="mx-auto w-full max-w-xl" data-id="element-187" data-mp="nhaibfgqdq5t" />
        </div>

        <div className="md:col-start-1 md:row-start-2" data-id="element-188" data-mp="1b4jsx6wuawrs">
          <p className="text-center text-[15px] leading-relaxed text-white/85 md:text-left" data-id="element-189" data-mp="1b637mt2ukzrg">
            Use the <strong className="text-white" data-id="element-190" data-mp="16cs5v6cw796e">POST-OP WOUND ASSESSMENT PATHWAY™</strong> to organize wound
            observations, document relevant changes, identify escalation triggers, and prepare structured clinical
            handoffs.
          </p>

          <ul className="mt-5 grid grid-cols-1 gap-2.5 sm:grid-cols-2" data-id="element-191" data-mp="2qwvysn4arzkb">
            {heroChecks.map(item => <li key={item} className="flex items-start gap-2.5 rounded-xl bg-white/[0.06] px-3 py-2.5" data-id="element-192" data-mp="2vtw6t3kpjce2">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-cta" data-id="element-193" data-mp="2humnhv17g25v">
                  <CheckIcon className="h-3.5 w-3.5 text-white" strokeWidth={3} aria-hidden="true" data-id="element-194" data-mp="2mvty01uqffg8" />
                </span>
                <span className="text-sm font-semibold leading-snug" data-id="element-195" data-mp="27zmgj9apks4n">{item}</span>
              </li>)}
          </ul>

          <div className="mt-7" data-id="element-196" data-mp="65dgf3oa29nu">
            <CTAButton ref={ctaRef} label="Get Instant Access" sublabel="Complete Blueprint · Just $27" data-id="element-197" data-mp="66eqb4tk4q3z" />
          </div>
          <div className="mt-4 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs font-semibold text-white/75 md:justify-start" data-id="element-198" data-mp="b2vokruh0kus">
            <span className="flex items-center gap-1.5" data-id="element-199" data-mp="1qop8au3bga43">
              <ZapIcon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-200" data-mp="1qlurdcjih7ff" />
              Instant Digital Access
            </span>
            <span className="flex items-center gap-1.5" data-id="element-201" data-mp="20mdcsbqq4vzg">
              <ShieldCheckIcon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-202" data-mp="20ksi8m4etd1l" />
              7-Day Guarantee
            </span>
          </div>
        </div>
      </div>
    </header>;
}